import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService} from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.scss']
})
export class CertificatesComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  certurl: SafeResourceUrl;
  title = "Certificati";
  subTitle = "EDAC - Certificati";
  innerHeight: any
  constructor(public navService: NavService, public translate: TranslatorService, private authService: AuthService, private route: ActivatedRoute, private sanitizer: DomSanitizer) { }


  ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('CertificatesIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.sended = true;
        frame.contentWindow?.postMessage('sstorage', this.ss);
        const qp = this.route.snapshot.queryParams;
        const commessa = qp['orderCode']; // es. 23IT001038520
        this.certurl = `${environment.rootInvoiceCertificates}${this.user.sub}&Commessa=${commessa}`;
        // console.log('certurl %o',this.certurl);
      }
    }

  }

  loadLabels(){
    this.translate.get('LABEL.CERTIFICATES').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user =  this.authService.user();
    console.log('send message to iframe %o',this.ss,this.user);
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
    ];
    this.navService.setActions(actions);

    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

}


